import { HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { $app } from '../../../app.service'
import {
   Doodle,
   DoodleApproveRequest,
   DoodleFilters,
   DoodleListResponse,
   DoodleVoteRequest
} from '../../../features/feature-doodles/models/interfaces/doodle.interface'
import { DoodleListParams } from '../../../features/feature-doodles/models/interfaces/doodle-list-params.interface'
import { MailingList } from '../../../features/feature-mailing-list/models/mailing-list.interface'
import { AppBasicService } from '../../services/app-basic.service'
import { AppBasicCalendarEvent } from '../../models/interfaces/app-basic-calendar-event.interface'

@Injectable()
export class CalendarEventsService extends AppBasicService {
   getMlistList(): Observable<MailingList[]> {
      if (this.console) console.log(this.logPrefix, 'getMlistList')

      const projectId = $app.getCurrentProjectId()

      return this.http.get<MailingList[]>(`${this._configService.apiUrl}/community-tools/projects/${projectId}/mailingLists`)
   }

   getMlistById(id: number): Observable<MailingList> {
      return this.http.get<MailingList>(`${this._configService.apiUrl}/community-tools/mailingLists/${id}`)
   }

   insertMlist(data: Partial<MailingList>): Observable<void> {
      const projectId = $app.getCurrentProjectId()

      return this.http.post<void>(`${this._configService.apiUrl}/community-tools/projects/${projectId}/mailingLists`, data)
   }

   updateMlist(id: number, data: Partial<MailingList>): Observable<void> {
      return this.http.put<void>(`${this._configService.apiUrl}/community-tools/mailingLists/${id}`, data)
   }

   deleteMlist(id: number): Observable<void> {
      return this.http.delete<void>(`${this._configService.apiUrl}/community-tools/mailingLists/${id}`)
   }

   getEventList(modePreview: boolean = false): Observable<AppBasicCalendarEvent[]> {
      if (this.console) console.log(this.logPrefix, 'getEventList')

      const projectId = $app.getCurrentProjectId()

      let httpOptions: { params?: HttpParams } = {}

      if (modePreview) {
         httpOptions['params'] = new HttpParams()
            .set('pageNumber', 0)
            .set('pageSize', 2)
            .set('startDate', this.date.transform(new Date(), 'YYYY-MM-dd') + 'T00:00:00')
      }

      return this.http.get<AppBasicCalendarEvent[]>(`${this._configService.apiUrl}/community-tools/projects/${projectId}/calendar/events`, httpOptions)
   }

   getEventById(id: number): Observable<AppBasicCalendarEvent> {
      const projectId = $app.getCurrentProjectId()

      return this.http.get<AppBasicCalendarEvent>(`${this._configService.apiUrl}/community-tools/projects/${projectId}/calendar/events/${id}`)
   }

   insertEvent(data: Partial<AppBasicCalendarEvent>): Observable<void> {
      const projectId = $app.getCurrentProjectId()

      return this.http.post<void>(`${this._configService.apiUrl}/community-tools/projects/${projectId}/calendar/events`, data)
   }

   updateEvent(id: number, data: Partial<AppBasicCalendarEvent>): Observable<void> {
      const projectId = $app.getCurrentProjectId()

      return this.http.put<void>(`${this._configService.apiUrl}/community-tools/projects/${projectId}/calendar/events/${id}`, data)
   }

   deleteEvent(id: number): Observable<void> {
      const projectId = $app.getCurrentProjectId()

      return this.http.delete<void>(`${this._configService.apiUrl}/community-tools/projects/${projectId}/calendar/events/${id}`)
   }

   getDoodleList(params: DoodleListParams, filters?: DoodleFilters): Observable<DoodleListResponse> {
      if (this.console) console.log(this.logPrefix, 'getDoodleList - PARAMS', params, ' - FILTERS', filters)

      const httpOptions = {
         params: new HttpParams().set('page', params.page).set('size', params.pageSize)
      }

      const requestBody = filters ? { type: filters.type.toUpperCase() } : {}
      const projectId = $app.getCurrentProjectId()

      return this.http.post<DoodleListResponse>(`${this._configService.apiUrl}/community-tools/projects/${projectId}/doodles:search`, requestBody, httpOptions)
   }

   getDoodleById(id: number): Observable<Doodle> {
      const projectId = $app.getCurrentProjectId()

      return this.http.get<Doodle>(`${this._configService.apiUrl}/community-tools/projects/${projectId}/doodles/${id}`)
   }

   insertDoodle(data: Doodle): Observable<void> {
      const projectId = $app.getCurrentProjectId()

      return this.http.post<void>(`${this._configService.apiUrl}/community-tools/projects/${projectId}/doodles`, data)
   }

   updateDoodle(data: Doodle): Observable<void> {
      const projectId = $app.getCurrentProjectId()

      return this.http.put<void>(`${this._configService.apiUrl}/community-tools/projects/${projectId}/doodles`, data)
   }

   deleteDoodle(id: number): Observable<void> {
      const projectId = $app.getCurrentProjectId()

      return this.http.delete<void>(`${this._configService.apiUrl}/community-tools/projects/${projectId}/doodles/${id}`)
   }

   voteDoodle(data: DoodleVoteRequest): Observable<void> {
      const projectId = $app.getCurrentProjectId()

      return this.http.post<void>(`${this._configService.apiUrl}/community-tools/projects/${projectId}/doodles:votes`, data)
   }

   approveDoodle(data: DoodleApproveRequest): Observable<void> {
      const projectId = $app.getCurrentProjectId()

      return this.http.post<void>(`${this._configService.apiUrl}/community-tools/projects/${projectId}/doodles:confirm`, data)
   }
}
